const PLANS_ADVANCED = {
    yearly: {
        name: 'yearly',
        price: '$25',
        interval: 'year',
    },
    monthly: {
        name: 'monthly',
        price: '$49',
        interval: 'month',
    }
};
const PLANS_PROFESSIONAL = {
    yearly: {
        name: 'yearly',
        price: '$319',
        interval: 'year',
    },
    monthly: {
        name: 'monthly',
        price: '$425',
        interval: 'month',
    }
};

const CANCEL_URL = 'https://insights.glassnode.com/pricing';

((window, document) => {
    setupButton('advanced', 'monthly');
    setupButton('professional', 'monthly');
})(window, document);

function setupButton(plan, billingCycle) {
    const baseElementId = ['pricing', plan, billingCycle].join('-');

    const guestUpgrade = document.getElementById(baseElementId + '-subscribe');

    if (guestUpgrade) {
        guestUpgrade.addEventListener('click', () => {
            localStorage.setItem(LS_KEYS.UPGRADE_PLAN, plan);

            plan === PLAN.ADVANCED
                ? localStorage.setItem(LS_KEYS.ADVANCED.BILLING_CYCLE, billingCycle)
                : localStorage.setItem(LS_KEYS.PROFESSIONAL.BILLING_CYCLE, billingCycle);
        })
    } else {
        const freeUpgrade = document.getElementById(baseElementId + '-upgrade-free');
        const memberUpgrade = document.getElementById(baseElementId + '-upgrade-member');

        if (freeUpgrade) {
            const tierId = freeUpgrade.getAttribute('data-plan-id');
            const dialog = setupFreeUpgradeDialog(
                plan,
                tierId,
                billingCycle,
                () => { freeUpgrade.disabled = true; }
            );

            freeUpgrade.addEventListener('click', () => { dialog.showModal() });
        }

        if (memberUpgrade) {
            const tierId = memberUpgrade.getAttribute('data-plan-id');
            const subId = memberUpgrade.getAttribute('data-subscription');
            const dialog = setupMemberUpgradeDialog(
                {
                    plan,
                    tierId,
                    subId,
                    billingCycle,
                    loading: () => { memberUpgrade.disabled = true; },
                }
            );

            memberUpgrade.addEventListener('click', () => { dialog.showModal() });
        }
    }
}

function processMemberUpgrade(memberUpgradeProps) {

    const { tierId, cadence, loading, callback, subId } = memberUpgradeProps;

    if (loading) {
        loading();
    }

    fetch('/members/api/session').then(resp => resp.text()).then(data => {
        fetch('/members/api/subscriptions/' + subId, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                cadence,
                cancel_at_period_end: false,
                identity: data,
                tierId,
            }),
        }).then(resp => {
            if (resp.ok) {
                window.location.reload();

                if (callback) {
                    callback();
                }
            }
        }).catch(e => {console.error(e)})

    }).catch(e => {console.error(e)});
}

function setupMemberUpgradeDialog(setupProps) {
    const { plan, tierId, billingCycle, loading, subId } = setupProps;

    const dialogId = 'pricing-' + plan + '-confirm-dialog';
    const dialog = document.getElementById(dialogId);
    const dialogConfirm = document.getElementById(dialogId + '-confirm');
    const dialogCancel = document.getElementById(dialogId + '-cancel');

    dialogConfirm.addEventListener('click', (e) => {
        processMemberUpgrade(
            {
                tierId,
                cadence: BILLING_CYCLE_CADENCE_MAP[billingCycle],
                loading: () => {
                    loading();
                    dialog.close();
                },
                subId,
            }
        );
    })

    dialogCancel.addEventListener('click', (e) => {
        dialog.close();
    });

    return dialog;
}

function processFreeUpgrade(tierId, cadence, loading) {
    if (loading) {
        loading();
    }

    fetch('/members/api/session').then(resp => resp.text()).then(data => {
        fetch('/members/api/create-stripe-checkout-session/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                cadence,
                identity: data,
                cancelUrl: CANCEL_URL,
                tierId,
            }),
        })
            .then(resp => resp.json())
            .then(data => {
                window.location.href = data.url;
            })
            .catch(e => {console.error(e)});

    }).catch(e => {console.error(e)});
}

function setupFreeUpgradeDialog(plan, tierId, billingCycle, loading) {
    const dialogId = 'pricing-' + plan + '-confirm-dialog';
    const dialog = document.getElementById(dialogId);
    const dialogConfirm = document.getElementById(dialogId + '-confirm');
    const dialogCancel = document.getElementById(dialogId + '-cancel');

    dialogConfirm.addEventListener('click', (e) => {
        processFreeUpgrade(tierId, BILLING_CYCLE_CADENCE_MAP[billingCycle], loading);
    })

    dialogCancel.addEventListener('click', (e) => {
        dialog.close();
    });

    return dialog;
}
